<script setup lang="ts">

import {timeAgo, time} from '../../helpers';

useHead({
    titleTemplate: '%s - The Political Room',
    bodyAttrs: {
        class: `post-template global-hash-load-more`
    }
});

const localePath = useLocalePath();
const {locale} = useI18n();
const {params: {slug}, query} = useRoute();

const podcastData = ref({} as any);
const colaboratorData = ref({} as any);
const nextArticleData = ref({} as any);
const prevArticleData = ref({} as any);
const isReady = ref(false);
const post_container = ref(null)
const voices = ref([])
const selectedVoice = ref(null)

/*const readingTime = (text: any) => {
    if (text === undefined) return 0;
    const wpm = 300;
    const words = text.trim().split(/\s+/).length;
    const time = Math.ceil(words / wpm);
    return time;
}*/

const loadPodcastData = async (): Promise<any> => {
    return await $fetch(`/api/strapi/podcast`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({

            preview: true,
            //previewSecret: query.secret,
            slug,

        })
    });
}

const checkIsPreview = (): boolean => {
    if (query && query.slug && query.slug.length > 0 && query.secret && query.secret.length > 0 && query.type === 'podcast') {
        return true;
    }

    return false;
}



onMounted(async () => {

    /*const podcast: any = await loadPodcastData()
    podcastData.value = podcast.podcast;
    console.log(podcastData.value.Title)*/

    /*colaboratorData.value = colaborator;
    nextArticleData.value = nextArticle && nextArticle[0];
    prevArticleData.value = prevArticle && prevArticle[0];

    if (article) {

        var d = document, s = d.createElement('script');
        s.src = 'https://thepoliticalroom.disqus.com/embed.js';
        s.setAttribute('data-timestamp', + new Date());
        (d.head || d.body).appendChild(s);

        // Añadimos el widget de twitter
        var e = document, c = e.createElement('script');
        c.src = 'https://platform.twitter.com/widgets.js';
        (e.head || e.body).appendChild(c);

        isReady.value = true;

    }

    if (process.client) {
        window.speechSynthesis.onvoiceschanged = () => {
            getVoicesByBrowser();
        }
    }*/
});
function decodeHTMLEntities(text: string) {
    let textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
}

function copyLink() {
    var copyText = document.getElementById("link-value") as HTMLInputElement;

    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText.value);
}

</script>

<template>
    <div style="">
        <div style="display: flex;justify-content: center;align-items: center;margin: 40px 0">
            <h1>PODCASTS</h1>
        </div>
        <section class="pod-container" style="">
            <iframe src="https://www.ivoox.com/player_es_podcast_863169_zp_1.html"
                     style="border: 1px solid #FFFFFF;"
                    height="400" frameborder="0" allowfullscreen="0" scrolling="no" loading="lazy"></iframe>
        </section>
    </div>
</template>

<style scoped>
    .pod-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 20px;
    }

    .pod-container iframe {
        width: 100%;
    }

    @media (min-width: 480px) {
        .pod-container {
            margin: 0 100px
        }
    }

    @media (min-width: 990px) {
        .pod-container iframe {
            width: 50%;
        }
    }

</style>